import { Modals } from '../../types';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import { UserConsent } from '../UserConsent/UserConsent';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import React, { lazy } from 'react';
import { useModals } from '../../context/ModalsContext';
import { GoToOtherTabModal } from '../GoToOtherTabModal/GoToOtherTabModal';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
import { InstallingLoader } from '../InstallLoader/InstallingLoader';
import { ModalWrapper } from './ModalWrapper';
import { LoadingDependentWrapper } from './LoadingDependentWrapper';
const LazyConnectDomainModal = /*#__PURE__*/lazy(() => import('../ConnectDomain/ConnectDomain'));
const LazyUpgradeToPremiumModal = /*#__PURE__*/lazy(() => import('../UpgradeToPremium/UpgradeToPremium'));
const LazySiteSelectorModal = /*#__PURE__*/lazy(() => import('../SiteSelectorModal/SiteSelectorModal'));
const LazyUpdateAppSuccessModal = /*#__PURE__*/lazy(() => import('../UpdateAppSuccessModal/UpdateAppSuccessModal'));
const LazyDevSiteSelectorModal = /*#__PURE__*/lazy(() => import('../DevModeSiteSelector/DevModeSiteSelectorModal'));
const LazyIncompatibleAppErrorModal = /*#__PURE__*/lazy(() => import('../IncompatibleAppErrorModal/IncompatibleAppErrorModal'));
const LazyBusinessFirstModal = /*#__PURE__*/lazy(() => import('../BusinessFirstModal/BusinessFirstModal'));
const LAZY_PICKERS_MAPPING = {
  [Modals.siteSelector]: LazySiteSelectorModal,
  [Modals.devModeSiteSelector]: LazyDevSiteSelectorModal
};
const LAZY_MODAL_MAPPING = {
  [Modals.connectDomain]: LazyConnectDomainModal,
  [Modals.upgradeToPremium]: LazyUpgradeToPremiumModal,
  [Modals.updateAppSuccess]: LazyUpdateAppSuccessModal,
  [Modals.incompatibleApp]: LazyIncompatibleAppErrorModal,
  [Modals.businessFirst]: LazyBusinessFirstModal
};
const ACTIVE_MODAL_MAPPING = {
  [Modals.none]: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  [Modals.error]: ErrorModal,
  [Modals.loading]: LoadingModal,
  [Modals.userConsent]: UserConsent,
  [Modals.goToOtherTab]: GoToOtherTabModal,
  [Modals.installingLoader]: InstallingLoader,
  ...LAZY_MODAL_MAPPING,
  ...LAZY_PICKERS_MAPPING
};
const getIsLazyModal = activeModal => activeModal in LAZY_MODAL_MAPPING;
const getIsPickerModal = activeModal => activeModal in LAZY_PICKERS_MAPPING;
export const ModalRenderer = () => {
  const {
    isLoadingInstaller
  } = useRenderControl();
  const {
    activeModal
  } = useModals();
  const isLazyModal = getIsLazyModal(activeModal);
  const isLazyPickerModal = getIsPickerModal(activeModal);
  const ActiveModal = ACTIVE_MODAL_MAPPING[activeModal];
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    isOpen: activeModal !== Modals.none || isLoadingInstaller,
    withModalComponent: !isLazyPickerModal,
    withSuspense: isLazyModal || isLazyPickerModal
  }, isLoadingInstaller && /*#__PURE__*/React.createElement(LoadingModal, null), /*#__PURE__*/React.createElement(LoadingDependentWrapper, null, /*#__PURE__*/React.createElement(ActiveModal, null)));
};
//# sourceMappingURL=ModalRenderer.js.map